import { AvailableCountries, type IUser } from 'types/users.types';
import useGetCurrentCustomerData from 'hooks/Authentication/useGetCurrentCustomerData';

/**
 * Pure function to check if BEFin feature is enabled for a user
 * We are using this in non-hook contexts like navigationGenerator
 */
export const isBEFinFeatureEnabled = (user?: IUser | null): boolean => {
  if (!user) return false;

  return user.country === AvailableCountries.belgium;
};

/**
 * React Hook to check if BEFin feature is enabled for current user
 * We are using this in React components like MoreMenu
 */
export const useIsBEFinFeatureEnabled = (): boolean => {
  const { data: user } = useGetCurrentCustomerData();
  return isBEFinFeatureEnabled(user);
};
